module.exports = __webpack_public_path__ + "img/action.d4d8fbdc.png";